import React, { useContext, useEffect, useState } from "react";
import Vehicleimg from "../../../src/assets/images/VehicleM&HCV.svg";
import { FilterContext } from "../../context/Filter";
import axios from "axios";
import BasicModal from "../Modals/BasicModal";
import RevenueDetails from "../../pages/piplineAndService/Revenuepop";
import mousepointer from "../../assets/images/mouse_hand.png";

const Revenuecard = () => {
  const [totalRevenue, settotalRevenue] = useState(null);
  const { arn: parArn, childArn } = useContext(FilterContext);
  // const { Narn: parArn, childArn } = useContext(FilterContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchTotalRevenue = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}totalRevenue`,
        { parArn, childArn }
      );
      settotalRevenue(res?.data?.result);
      return res.data;
    } catch (error) {
      console.error(`API fetch error (${"totalRevenue"}):`, error);
      return null;
    }
  };

  useEffect(() => {
    fetchTotalRevenue();
  }, [parArn, childArn]);
  return (
    <div className="flex flex-col gap-2 m-1">
      {/* Top row: Sales Revenue + Spares Revenue */}
      <div className="flex gap-2">
        {/* Total Revenue */}
        <div className="bg-[#C6FFE7] flex-1 p-3 rounded-md shadow-md flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={Vehicleimg} alt="Total" />
            <h1 className="text-sm font-semibold">Total Revenue</h1>
          </div>
          {/* <h6 className="text-xs font-semibold">{totalRevenue?.result ?? 0} cr.</h6> */}
          <h6 className="text-xs font-semibold">
            {`${(totalRevenue?.total_revenue / 10000000).toFixed(2)} Cr` ||
              "0 Cr"}
          </h6>
        </div>

        {/* Spares Revenue */}
        <div className="bg-[#FFE3BA] flex-1 p-3 rounded-md shadow-md flex justify-between items-center">
          <div className="flex items-center gap-3">
            <img src={Vehicleimg} alt="Spares" />
            <h1 className="text-sm font-semibold">Spares Revenue</h1>
          </div>

          <div className="flex items-center gap-2">
            {/* <h6 className="text-xs font-semibold">{sparesRevenue?.result ?? 0} cr.</h6> */}
            <h6 className="text-xs font-semibold">
              {`${(totalRevenue?.spares_revenue / 1_00_00_000).toFixed(
                2
              )} Cr` || "0 Cr"}
            </h6>

            <BasicModal
              open={isModalOpen}
              handleOpenModal={() => setIsModalOpen(true)}
              handleCloseModal={() => setIsModalOpen(false)}
              title="Revenue Details"
              trigger={
                <button className="p-1" onClick={() => setIsModalOpen(true)}>
                  <img
                    src={mousepointer}
                    alt="Open Modal"
                    className="w-4 h-4"
                  />
                </button>
              }
            >
              <RevenueDetails />
            </BasicModal>
          </div>
        </div>
      </div>

      {/* Bottom row: Total Revenue + JC Revenue */}
      <div className="flex gap-2">
        {/* Sales Revenue */}
        <div className="bg-[#D0EBFF] flex-1 p-3 rounded-md shadow-md flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={Vehicleimg} alt="Vehicle" />
            <h1 className="text-sm font-semibold">Sales Revenue</h1>
          </div>
          {/* <h6 className="text-xs font-semibold">{totalRevenue?.result ?? 0} cr.</h6> */}
          <h6 className="text-xs font-semibold">
            {`${(totalRevenue?.sales_revenue / 1_00_00_000).toFixed(2)} Cr` ||
              "0 Cr"}
          </h6>
        </div>

        {/* JC Revenue */}
        <div className="bg-[#C8FAFF] flex-1 p-3 rounded-md shadow-md flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={Vehicleimg} alt="JC" />
            <h1 className="text-sm font-semibold">JC Revenue</h1>
          </div>
          {/* <h6 className="text-xs font-semibold">{JCRevenue?.result ?? 0} cr.</h6> */}
          <h6 className="text-xs font-semibold">
            {`${(totalRevenue?.jc_revenue / 10000000).toFixed(2)} Cr` || "0 Cr"}
          </h6>
        </div>
      </div>
    </div>
  );
};

export default Revenuecard;
